<template>
  <img :src="src" :alt="alt" :class="{ 'is-rounded': rounded }" />
</template>

<script>
export default {
  name: "ProfileImg",
  props: {
    large: Boolean,
    rounded: Boolean,
    user: Object,
  },
  computed: {
    src() {
      if (!this.user) {
        return `/images/default-profile-mini.png`
      }
      if (this.large) {
        return this.user.image_url_large
      } else {
        return this.user.image_url
      }
    },

    alt() {
      if (this.user) {
        return `${this.user.screen_name} profile picture`
      } else {
        return 'Default Twitter logo'
      }
    }
  }
}
</script>

<style scoped>

</style>
